import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const swiperReviews = (container) => {
	new Swiper(container, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 0,
		autoHeight: true,
		navigation: {
			prevEl: container.parentElement.querySelector('.js-swiper-prev'),
			nextEl: container.parentElement.querySelector('.js-swiper-next'),
		},
		pagination: {
			el: container.parentElement.querySelector('.js-swiper-pagination'),
			clickable: true,
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 1,
			},
			992: {
				slidesPerView: 'auto',
			},
		},
	});
};
